module.exports = __webpack_public_path__ + "static/media/time.745a6521.svg";